export interface OperationOption {
  value: string;
  label: string;
}

export const operationOptions: OperationOption[] = [
  { value: "insert", label: "Insert" },
  { value: "update", label: "Update" },
  { value: "upsert", label: "Upsert" },
];

// Statuses known to be non-terminal per the backend hand-over doc. Anything
// else (including statuses not listed here) is treated as potentially
// terminal, since the final status string comes from Zoho's own callback
// and isn't enumerated in the backend.
export const IN_PROGRESS_STATUSES = ["AWAITING_UPLOAD", "FILE_UPLOADED", "JOB_CREATED"];

export const POLL_INTERVAL_MS = 5000;
export const POLL_TIMEOUT_MS = 10 * 60 * 1000;
